import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import './PublicationAdded.scss';

const ExpansionPanel = withStyles({
    root: {
      boxShadow: 'none',
      marginBottom: 16,
      backgroundColor: 'white',
      marginTop: 8,
      padding: 0,
      '&$expanded': {
        '&:first-child': {
          marginTop: 24,
        },
      },
    },
  })(MuiExpansionPanel);
  
  const ExpansionPanelSummary = withStyles({
    root: {
      padding: 0,
      minHeight: 56,
      position: 'relative',
    },
    content: {
      margin: 0,
      width: '100%',
      '@media screen and (max-width:768.98px)': {
        height: 160,
      },
      '&$expanded': {
        margin: 0,
      },
    },
    expandIcon: {
      color: '#6ecc47',
      alignSelf: 'flex-start',
      position: 'absolute',
      right: 16,
    },
  })(MuiExpansionPanelSummary);
  
  const ExpansionPanelDetails = withStyles({
    root: {
      padding: 0,
      color: '#484848',
      display: 'block',
    },
  })(MuiExpansionPanelDetails);

const PublicationPanel = (props) => {
    const { elements, expanded } = props
    
    return (
            <ExpansionPanel expanded={expanded}>
                {expanded ? null :
                    <ExpansionPanelSummary
                        style={{backgroundColor: 'white'}}
                    >
                        <div style={{ width: '100%' }}>
                            {elements && !expanded ? elements.map((elem, index) => {
                                const { title, url, year } = elem;
                                if (index === 0 || index === 1) {
                                    return (
                                        <div className="publicationAdded">
                                            <div className="publicationAdded_limit">
                                                <ul className="publicationAdded_containerPreview">
                                                    <li className="publicationAdded_containerPreview_list">
                                                        <div className="publicationAdded_containerPreview_info">
                                                            {title ?
                                                                <p className="publicationAdded_paragraph1">{title}</p> :
                                                                null
                                                            }
                                                            {url ?
                                                                <a
                                                                    href={`${url}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer nofollow"
                                                                    className="publicationAdded_paragraph2"
                                                                >
                                                                    {url}
                                                                </a> :
                                                                null
                                                            }
                                                            {year ?
                                                                <p className="publicationAdded_paragraph3">{year}</p> :
                                                                null
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )
                                }
                                }) : null
                            }
                        </div>
                    </ExpansionPanelSummary>
                 }

                    <ExpansionPanelDetails>
                        <div style={{ width: '100%' }}>
                            {elements && elements.map((elem, index) => {
                                const { title, url, year } = elem;
                                return (
                                    <div className="publicationAdded">
                                        <div className="publicationAdded_limit">
                                            <ul className="publicationAdded_containerPreview">
                                                <li className="publicationAdded_containerPreview_list">
                                                    <div className="publicationAdded_containerPreview_info">
                                                        {title ?
                                                            <p className="publicationAdded_paragraph1">{title}</p> :
                                                            null
                                                        }
                                                        {url ?
                                                            <a
                                                                href={`${url}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer nofollow"
                                                                className="publicationAdded_paragraph2"
                                                            >
                                                                {url}
                                                            </a> :
                                                            null
                                                        }
                                                        {year ?
                                                            <p className="publicationAdded_paragraph3">{year}</p> :
                                                            null
                                                        }
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                )
                                })
                            }
                        </div>
                    </ExpansionPanelDetails>
            </ExpansionPanel>
    )
}

export default PublicationPanel
